import React, {Component} from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import { isMobile } from '../actions/Settings'

class WelcomePage extends Component {

    componentDidMount() {
        const { is_mobile, history } = this.props
        if ( is_mobile ) {
            history.push('/wd/')
        }
    }
    
    render() {
        return (

            <div className="welcome-page">
              <div className="welcome-page-content">
                Welcome to ImpTime.
              </div>
            </div>
        )
    }
}

function mapStateToProps(state, props) {

    return {
        is_mobile: isMobile()
    }
}

export default withRouter(connect(mapStateToProps)(WelcomePage))




// WEBPACK FOOTER //
// ./src/containers/WelcomePage.js